module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./GrantAgentView.js"));
	}, "GrantAgentView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GrantAgentView!./src/pages/Shop/Member/Agreements/GrantAgent/GrantAgentView.js
// module id = 1872
// module chunks = 367